import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from '../../config/axiosInstance';
import moment from 'moment';
import 'moment/min/locales';
import StarIcon from '@material-ui/icons/Star';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import SignalWifiNoInternet from '@material-ui/icons/SignalCellularConnectedNoInternet0BarOutlined';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Typography, ExpansionPanelSummary, ExpansionPanelDetails, ExpansionPanel, Grid } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { fetchTaskSchedules, updateTaskScheduleName } from '../../store/actions/taskSchedule';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';
import TaskScheduleDialog from "../../components/TaskSchedule/TaskScheduleDialog";
import TaskSchedulesOfflinePoints from "../../components/TaskSchedule/TaskSchedulesOfflinePoints";
import TaskScheduleJustification from "../../components/TaskSchedule/TaskScheduleJustification";
import TaskScheduleDuplicatePoint from "../../components/TaskSchedule/TaskScheduleDuplicatePoint";

import Carimbo from '../../assets/images/Carimbo/Carimbo.png';
import Tooltip from '@material-ui/core/Tooltip';

class TaskSchedules extends React.Component {

  state = {
    isPremium: false,
    eventTodos: [],
    scheduleModal: false,
    editModal: false,
    editStatus: '',
    editDescricao: '',
    descricaoEventOfflinePoint: '',
    currentStatus: {
      id: '',
      timeclockId: '',
      typeEventId: '',
      employeeId: '',
      description: '',
      statusaction: '',
      rulerdetailsjson: {
        timeclockLocation: {
          lat: '',
          long: '',
        },
        allowedLocations: [
          {
            lat: '',
            long: '',
            range: '',
            distanceFromTc: '',
          }
        ]
      },
      employee: {
        name: '',
      },
      timeclock: {
        id: '',
        lat: '',
        lng: '',
        addressLocation: '',
        creationDate: '',
        type: '',
        dtRegister: '',
      }
    },
    date: '',
    time: '',
    justification: '',
    statusPoint: '',
    currentStatusOfflinePoints: {
      id: '',
      dtRegister: '',
      employee: {
        name: '',
      },
      timeclock: {
        dtRegister: '',
        type: '',
      }
    },
  };

  componentDidMount() {
    this.props.onFetchTaskSchedules();
  }
  componentWillReceiveProps() {
    this.actions = [];
    this.forceUpdate();
    this.isPremium();
  }

  isPremium = () => {
    const validaetPremium = JSON.parse(localStorage.getItem('privileges')).isExportAfd;
    if (validaetPremium === false) {
      this.setState({ isPremium: false });
    } else {
      this.setState({ isPremium: true });
    }
  }


  finishActions = () => {
    axios
      .post('timeSheet/actions', {
        employeeId: this.state.currentStatus.employeeId,
        actions: [{
          action: "SUB",
          dtRegister:
            `${this.state.currentStatus.timeclock.dtRegister} ${this.state.time}`,
          id: this.state.currentStatus.timeclock.id,
          isRemake: false,
          justification: this.state.editDescricao,
          name: "editar",
          type: this.state.currentStatus.timeclock.type,
        }],
      })
      .then((response) => {
      })
      .catch((error) => {
        this.props.onMessage(error);
      });
  }

  approveAll = (status) => {
    if (status === "outOfpoints") {
      axios
        .put('/event/', {
          id: this.props.taskschedules.filter(f => f.typeEventId === 1).map(i => i.id),
          statusaction: "APROVADO",
          description: "EventoIgnorarTodos",
        })
        .then((response) => {
          this.componentDidMount(this.props.onFetchTaskSchedules);
        })
        .catch((error) => {
          this.props.onMessage(error);
        });
    } else {
      let allPoints = [];
      allPoints = this.props.taskschedules.filter(f => f.typeEventId === 2);
      allPoints.map((point) => {
        axios
          .post('timeSheet/actions', {
            actions: [{
              action: "OFF",
              id: point.timeclockId,
              isRemake: false,
              dtRegister: point.timeclock.dtRegister,
              name: "ativar",
            }],
            employeeId: point.employeeId,
          })
        this.props.onUpdateTaskScheduleName(point.id, 'APROVADO', 'Ponto Offline Aprovado');
      })
      this.componentDidMount(this.props.onFetchTaskSchedules);
      this.componentDidMount(this.props.onFetchTaskSchedules);
      this.setState({ openModalOfflinePoints: false });
      this.setState({ openModalOfflinePointsConfirm: false });
    }
  }

  handleClickOpen = (status) => {
    if (status === "pointsOutOfPlace") {
      this.setState({ openPointsOutOfPlaceApproveAll: true });
    } else {
      this.setState({ openOfflinePointsApproveAll: true });
    }
  };

  handleClose = (status) => {
    if (status === "pointsOutOfPlace") {
      this.setState({ openPointsOutOfPlaceApproveAll: false });
    } else {
      this.setState({ openOfflinePointsApproveAll: false });
    }
  };

  handleClickOpe = (item) => {
    const currentStatusOfflinePoints = this.props.taskschedules.find(tasks => tasks.id === item);
    this.setState({
      openModalOfflinePoints: true,
      currentStatusOfflinePoints,
    });
  };

  handleCloseOfflinePoints = () => {
    this.setState({ openModalOfflinePoints: false });
  };

  openModalOfflinePointsConfirm = (status) => {
    if (status === 'REJEITADO') {
      this.setState({ openModalOfflinePointsConfirm: true });
      this.setState({ statusPoint: 'REJEITADO' })
    } else if (status === 'APROVADO') {
      this.setState({ openModalOfflinePointsConfirm: true });
      this.setState({ statusPoint: 'APROVADO' })
    } else {
      this.setState({ statusPoint: '' });
      this.setState({ openModalOfflinePointsConfirm: false });
    }
  };

  closeModalOfflinePointsConfirm = () => {
    this.setState({ statusPoint: '' })
    this.setState({ openModalOfflinePointsConfirm: false });
  };

  handleActionClick = (action, item) => {
    const currentStatus = this.props.taskschedules.find(tasks => tasks.id === item);
    if (action === 'APROVADO') {
      this.setState({
        editModal: true,
        currentStatus,
        editStatus: 'APROVADO',
      });
    } else if (action === 'REJEITADO') {
      this.setState({
        editModal: true,
        currentStatus,
        editStatus: 'REJEITADO',
        actions: this.finishActions,
      });
    } else {
      this.setState({ scheduleModal: true, currentStatus });
    }
  };

  handleActionOfflinePoints = (action, item) => {
    if (action === 'APROVADO') {
      axios
        .post('timeSheet/actions', {
          actions: [{
            action: "OFF",
            id: item.timeclockId,
            isRemake: false,
            dtRegister: item.timeclock.dtRegister,
            name: "ativar",
          }],
          employeeId: item.employeeId,
        })
      this.props.onUpdateTaskScheduleName(item.id, 'APROVADO', 'Ponto Offline Aprovado');
      this.componentDidMount(this.props.onFetchTaskSchedules);
      this.componentDidMount(this.props.onFetchTaskSchedules);
      this.setState({ openModalOfflinePoints: false });
      this.setState({ openModalOfflinePointsConfirm: false });
    } else {
      axios
        .post('timeSheet/actions', {
          actions: [{
            action: "REM",
            category: null,
            categoryRemake: "",
            dtRegister: item.timeclock.dtRegister,
            id: item.timeclockId,
            isRemake: false,
            justification: "Ponto offline recusado",
            name: "inativar",
          }],
          employeeId: item.employeeId,
        })
      this.props.onUpdateTaskScheduleName(item.id, 'REJEITADO', 'Ponto Offline Rejeitado');
      this.componentDidMount(this.props.onFetchTaskSchedules);
      this.componentDidMount(this.props.onFetchTaskSchedules);
      this.setState({ openModalOfflinePoints: false });
      this.setState({ openModalOfflinePointsConfirm: false });
    }
  };

  handleChange = (event, type) => {
    switch (type) {
      case 'descricao':
        this.setState({ editDescricao: event.target.value });
        break;

      case 'time':
        this.setState({ time: event.target.value });
        break;

      case 'descricaoEventOfflinePoint':
        this.setState({ descricaoEventOfflinePoint: event.target.value });
        break;

      default:
        break;
    }
  };

  handleActionCancel = () => {
    this.setState({ deleteModal: false, scheduleModal: false, editModal: false });
    this.setState({ editDescricao: '', time: '' });
  };

  handleEditConfirm = () => {
    this.props.onUpdateTaskScheduleName(this.state.currentStatus.id, this.state.editStatus, this.state.editDescricao);
    this.setState({ editDescricao: '', time: '' });
    this.componentDidMount(this.props.onFetchTaskSchedules);
    this.componentDidMount(this.props.onFetchTaskSchedules);
    this.handleActionCancel();
  };

  renderOfflinePoints = (taskschedules, actionsC, loading) => {
    const OfflineColumns = [
      { name: 'dtRegister', label: 'Data' },
      { name: 'timeRegister', label: 'Hora' },
      { name: 'type', label: 'Tipo' },
      { name: 'name', label: 'Nome' },
      { name: 'addressLocation', label: 'Endereço' },
    ];
    return (<div style={{ display: 'block' }}>
      <DataTable
        rows={taskschedules.filter(f => f.typeEventId === 2).map(i => ({
          id: i.id,
          timeclockId: i.timeclockId,
          dtRegister: (moment(i.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy')),
          timeRegister: (moment(i.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm')),
          type: i.timeclock.type == 'I' ? 'Entrada' : 'Saída',
          name: i.employee.name,
          addressLocation: i.timeclock.addressLocation,
        }))}
        columns={OfflineColumns}
        outRowsPerPage={5}
        actions={actionsC}
        loading={loading}
      />
    </div>)
  }

  renderPointsOutOfPlace = (taskschedules, actions, loading) => {
    const columns = [
      { name: 'dtRegister', label: 'Data' },
      { name: 'timeRegister', label: 'Hora' },
      { name: 'type', label: 'Tipo' },
      { name: 'name', label: 'Nome' },
      { name: 'addressLocation', label: 'Endereço' },
    ];
    return (<div style={{ display: 'block' }}>
      <DataTable
        rows={taskschedules.filter(i => i.typeEventId === 1).map(i => ({
          id: i.id,
          dtRegister: (moment(i.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy')),
          timeRegister: (moment(i.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm')),
          type: i.timeclock.type == 'I' ? 'Entrada' : 'Saída',
          name: i.employee.name,
          addressLocation: i.timeclock.addressLocation,
        }))}
        columns={columns}
        outRowsPerPage={5}
        actions={actions}
        loading={loading}
      />
    </div>)
  }

  render() {
    const { taskschedules, loading } = this.props;
    const { editModal, editDescricao, time, scheduleModal, currentStatus, currentStatusOfflinePoints, openModalOfflinePoints, openModalOfflinePointsConfirm } = this.state;
    const { openPointsOutOfPlaceApproveAll, openOfflinePointsApproveAll, descricaoEventOfflinePoint } = this.state;

    const actions = [
      {
        name: 'Detalhes',
        icon: InfoOutlinedIcon,
        onClick: item => this.handleActionClick('Visualizar', item.id),
      },
    ];
    const actionsC = [
      {
        name: 'Detalhes',
        icon: SignalWifiNoInternet,
        onClick: item => this.handleClickOpe(item.id),
      },
    ];

    return (
      <React.Fragment>
        <ContentHeader
          title="Lista de Atividades"
          subtitle="Lista com as atividades pendentes">

          {/* <Tooltip title="Funcionalidade Premium.">
            <Grid>
              <Link to="/assinatura">
                <img src={Carimbo} alt="Puntu"
                  style={{ width: '117px', position: 'absolute', right: '10px', top: '108px' }} />
              </Link>
            </Grid>
          </Tooltip> */}
        </ContentHeader>


        <Paper elevation={2} style={{ margin: 10 }}>
          {
            !taskschedules.filter(i => i.typeEventId === 1).length ?
              (
                <Typography align="center" style={{ padding: 10 }}> Não há pontos fora do local no momento.</Typography>
              ) :
              <ExpansionPanel style={{ marginTop: 5 }}>
                <ExpansionPanelSummary expandIcon={<ExpandMore />} IconButtonProps={{ style: { position: 'absolute', right: '14px' } }}>
                  <Typography item md={5}> Existem {taskschedules.filter(i => i.typeEventId === 1).length} pontos fora do local.</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ display: 'block' }}>
                  {this.renderPointsOutOfPlace(taskschedules, actions, loading)}
                  <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                  }}>
                    {this.state.isPremium == true ?
                      (<Button variant="outlined" onClick={status => this.handleClickOpen("pointsOutOfPlace")} color="primary" style={{ left: '-21px', bottom: ' -8px' }}>
                        Limpar Eventos
                      </Button>
                      ) :
                      <DialogActions>
                        <DialogContentText style={{ fontSize: '14px', color: '#2880ca', right: '20px', bottom: '-15px', position: 'relative' }}>
                          *Assine o Plano Premium para acessar as ações.
                        </DialogContentText>
                        <Button variant="contained" color="primary" component={Link} style={{ left: '-21px', bottom: ' -8px' }} to='/assinatura'>
                          <StarIcon />  RESOLVA AQUI! SEJA PREMIUM <StarIcon />
                        </Button>
                      </DialogActions>
                    }
                    <Dialog
                      open={openPointsOutOfPlaceApproveAll}
                      onClose={status => this.handleClose("pointsOutOfPlace")}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">
                        Limpar todos os pontos fora do local.
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          Você tem certeza que deseja efetuar esta ação?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={status => this.handleClose("pointsOutOfPlace")} style={{ left: '-21px', bottom: ' 9px' }}> CANCELAR </Button>
                        <Button onClick={status => this.approveAll("outOfpoints")} variant="contained" color="primary" style={{ left: '-21px', bottom: ' 9px' }}> CONFIRMAR </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
          }
        </Paper >

        <TaskSchedulesOfflinePoints
          taskschedules={taskschedules}
          renderOfflinePoints={this.renderOfflinePoints}
          openModalOfflinePoints={openModalOfflinePoints}
          handleCloseOfflinePoints={this.handleCloseOfflinePoints}
          currentStatusOfflinePoints={currentStatusOfflinePoints}
          openModalOfflinePointsConfirm={this.openModalOfflinePointsConfirm}
          openModalOfflinePointsConfirmState={openModalOfflinePointsConfirm}
          closeModalOfflinePointsConfirm={this.closeModalOfflinePointsConfirm}
          handleActionOfflinePoints={this.handleActionOfflinePoints}
          openOfflinePointsApproveAll={openOfflinePointsApproveAll}
          handleClickOpen={this.handleClickOpen}
          handleClose={this.handleClose}
          statusPoint={this.state.statusPoint}
          descricaoEventOfflinePoint={this.state.descricaoEventOfflinePoint}
          handleChange={this.handleChange}
          approveAll={this.approveAll}
          loading={loading}
          actionsC={actionsC}
          isPremium={this.state.isPremium}
        />

        <TaskScheduleDuplicatePoint
          isPremium={this.state.isPremium}
        />

        <TaskScheduleJustification
          isPremium={this.state.isPremium}
        />

        <TaskScheduleDialog
          open={scheduleModal}
          onClose={this.handleActionCancel}
          schedule={currentStatus}
          scheduleActions={this.handleActionClick}
          isPremium={this.state.isPremium}
        />
        {
          this.state.editStatus === 'APROVADO' ?
            (
              <Dialog open={editModal} onClose={this.handleActionCancel}>
                <DialogTitle>Você esta aprovando esse Ponto.</DialogTitle>
                <DialogContent>
                  <DialogContentText>Deixe uma descrição.</DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    name="name"
                    label="Descrição"
                    type="text"
                    onChange={event => this.handleChange(event, 'descricao')}
                    value={editDescricao}
                    required
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleActionCancel}>CANCELAR</Button>
                  {
                    this.state.editDescricao === '' ?
                      (
                        <Button disabled variant="contained" color="primary" type="submit" onClick={this.handleEditConfirm} autoFocus>
                          CONFIRMAR
                        </Button>
                      ) :
                      <Button variant="contained" color="primary" type="submit" onClick={this.handleEditConfirm} autoFocus>
                        CONFIRMAR
                      </Button>
                  }
                </DialogActions>
              </Dialog>
            ) :
            <Dialog open={editModal} onClose={this.handleActionCancel}>
              <DialogTitle>Você esta rejeitando esse Ponto.</DialogTitle>
              <DialogContent>
                <div>
                  <DialogContentText>Informe o novo horário e uma justificativa.</DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    label="Horário"
                    name="name"
                    type="time"
                    value={time}
                    onChange={event => this.handleChange(event, 'time')}
                    required
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    autoFocus
                    margin="dense"
                    name="name"
                    label="justificativa"
                    type="text"
                    onChange={event => this.handleChange(event, 'descricao')}
                    value={editDescricao}
                    required
                    fullWidth
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleActionCancel}>CANCELAR</Button>
                {
                  this.state.justification && this.state.editDescricao == '' ?
                    (
                      <Button disabled variant="contained" color="primary" type="submit" onClick={this.handleEditConfirm} autoFocus>
                        CONFIRMAR
                      </Button>
                    ) :
                    <Button variant="contained" color="primary" type="submit" onClick={() => { this.handleEditConfirm(); this.finishActions(); }} autoFocus>
                      CONFIRMAR
                    </Button>
                }
              </DialogActions>
            </Dialog>
        }
      </React.Fragment >
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  taskschedules: state.taskSchedule.tasks
});

const mapDispatchToProps = dispatch => ({
  onFetchTaskSchedules: () => dispatch(fetchTaskSchedules()),
  onUpdateTaskScheduleName: (id, name, description) => dispatch(updateTaskScheduleName(id, name, description)),
});

export default connect(mapStateToProps, mapDispatchToProps,)(TaskSchedules);
